<template>
  <div>
    <div class="xx-re-text" v-html="brMag(message.content)"></div>

    <div class="xx-hc-box" v-if="message.title">
      <div class="xx-hc-title">{{ message.title }}</div>
      <div class="xx-hc-btn" v-if="!message.tag">
        <el-button
          type="primary"
          size="small"
          v-if="message.yesTag"
          @click="handlePost(1, message.yesTag)"
          >{{ message.yesTag }}</el-button
        >
        <el-button
          type="warning"
          size="small"
          v-if="message.noTag"
          @click="handlePost(2, message.noTag)"
          >{{ message.noTag }}</el-button
        >
      </div>
      <div class="xx-hc-xz" v-else>
        您的选择：<span class="xx-hc-xz-xz">{{ message.tag }}</span>
      </div>
    </div>

    <div class="xx-hc-content" v-html="replaceRemark(message.remark)"></div>
  </div>
</template>
<script>
import { updateReceipt } from "@/api/receipt";
import { isEmpty } from "@/utils/help";
export default {
  name: "Message",
  props: {
    message: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  created() {
    if (this.message.isOpen != 1) {
      this.$emit("readMessage", this.message.id);
    }
  },
  // created() {
  // },
  methods: {
    brMag(str) {
      if (!isEmpty(str)) {
        return str.replace(/\n/g, "<br/>");
      }
    },
    replaceRemark(str) {
      if (!isEmpty(str)) {
        return str.replace(/\n|\r\n/g, "<br>").replace(/ /g, " &nbsp");
      }
    },
    handlePost(tagType, tag) {
      if (tagType == 2) {
        this.$confirm("确定 [" + tag + "] 吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          customClass: "confirm",
        }).then(() => {
          this.$emit("updateMessageStatus", tagType, tag);
        });
      } else {
        this.$emit("updateMessageStatus", tagType, tag);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.xx-re-text {
  font-size: 16px;
  color: #191919;
  line-height: 1.7;
}
.xx-hc-box {
  background-color: #f7f7f7;
  padding: 15px;
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .xx-hc-title {
    font-size: 18px;
    color: #191919;
    font-weight: bold;
  }
  .xx-hc-btn {
    margin-top: 15px;
  }
  .xx-hc-xz {
    margin-top: 15px;
    font-size: 16px;
    background-color: #fff0ed;
    padding: 12px;
    border-radius: 4px;
    border: 1px solid #ffddd6;
    color: #ff2000;
    .xx-hc-xz-xz {
      background-color: #ff2000;
      color: #fff;
      padding: 6px;
      border-radius: 3px;
    }
  }
}
.xx-hc-content {
  font-size: 16px;
  color: #191919;
  line-height: 1.7;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Message.vue